import cloneDeep from 'lodash/cloneDeep';
import {sendRequest, API_ROOT } from '../supplementary_components/requests';
import { LOAD_ADD_CONF } from '../pages/loads/loadAddConf';
import { TRUCK_ADD_CONF } from '../pages/trucks/truckAddConf';
import { TRAILER_ADD_CONF} from '../pages/trailers/trailerAddConf';
import { EMPLOYEE_ADD_CONF } from '../pages/employees/employeeAddConf';
import { DRIVER_ADD_CONF } from '../pages/drivers/driverAddConf';
import { addPopup, addNotification } from '../supplementary_components/store'
import { Form } from '../general_components/forms/Form';
import { NestedValueExtractor } from "../general_components/content_management/list_view/listView";
import { COMPANY_ADD_CONF } from '../pages/company/comapnyAddConf';


export function generateUpdatedVersionOfTheObject(id, category, updatedData, processImmutableField){
    return new Promise((resolve) => {
        if(category === "drivers" || category === "trailers" || category === "employees" || category === "trucks" ){
            if(updatedData.dismissRequestWithSuccessMsg)resolve(updatedData);
            updatedData['id'] = id;
            if(processImmutableField){
                for (let key in updatedData){
                    if(updatedData[key] !== undefined){
                        updatedData[key] = processImmutableField(null, updatedData[key], key)
                    }
                }
            }
            resolve(updatedData);
        }else{
            sendRequest("GET", `${API_ROOT}${category}/${id}`,null, (val)=>{
                for (let key in val){
                    if(updatedData[key] !== undefined){
                        if(processImmutableField){
                            val[key] = processImmutableField(val[key], updatedData[key], null)
                        }else{
                            val[key] = updatedData[key];
                        }
                    }
                }
                // if(category === 'loads' && val["stops"] && typeof(val["stops"]) !== 'string'){
                //     val["stops"] = JSON.stringify(val["stops"]);
                // }
                
                resolve(val);
            }, ()=>{
                resolve(null)
                addNotification({message:`Something went wrong`, type:'alert'});
            }, null)
        }
        
    })
}

const copyConfigurationsWithNecesseryColumns = (REFERENCE_CONF, sectionColumns, updatedParameters, customCheckBeforeSending)=>{
    const newConf = cloneDeep(REFERENCE_CONF);
    if(customCheckBeforeSending){
        newConf.customCheckBeforeSending = customCheckBeforeSending;
    }
    const selectedConfColumns = [];
    const getColumnFromArrayByName = (name, array) => {
        for(const column of array){
            if(column.name === name) return column;
        }
        return null;
    }
    const findColumnByName = (columnName)=>{
        let result =  getColumnFromArrayByName(columnName, selectedConfColumns);
        if(result !== null)return {"column":result, 'alreadyAdded' : true};
        result =  getColumnFromArrayByName(columnName, newConf.columns);
        if(result !== null)return {"column":result, 'alreadyAdded' : false};
        return result;
    }
    sectionColumns.forEach((item)=> {
        if(!item)return;
        
        if(item.notInAddForm){
            // console.log(item);
            selectedConfColumns.push(item)
        }else if(item.subMenu){
            
            const result = findColumnByName(item.parentFieldName);
            result.column.subMenu["openByDefault"] = true;
            const subColumn = getColumnFromArrayByName(item.subMenuColumnName, result.column.subMenu.columns);
            subColumn['defaultValue'] = item.defaultValue;
            subColumn['autoComplete'] = item.autoComplete;
            // 
            if(!result.alreadyAdded){
                selectedConfColumns.push(result.column)
            }
        }else{
            try {
                const column = findColumnByName(item.nameInAddConfForm).column;
                column["defaultValue"] = item.defaultValue;
                column["ignoredSubMenu"] = item.ignoredSubMenu;
                column["ignoreChecks"] = item.ignoreChecks;
                column["saveOldValueInDataAttribute"] = item.saveOldValueInDataAttribute;
                column['customDisplayMode'] = item.customDisplayMode;
                column['customDisabledVals'] = item.customDisabledVals;
                selectedConfColumns.push(column)
            } catch (error) {
            }
            
        }
        
    });
    newConf.columns = selectedConfColumns;
    for (let key in updatedParameters){
        
        newConf[key] = updatedParameters[key];
    }
    return newConf;
}


export const SECTION_UPDATE_FORM_GENERATOR = (formTitle, itemName, category, itemId, itemAddConf, columns, setDataMethod, customSaveButtonText, processImmutableField, customCheckBeforeSending, ignoreChangesTracker, customAddLink)=>{
    
    const updatedParameters ={
        customMethod:"PATCH",
        formTitle:`${formTitle}`,
        name:`Edit ${itemName}`,
        addLink: customAddLink || `${API_ROOT}${category}/edit`,
        customSubmitButton:customSaveButtonText?customSaveButtonText:"Save Changes",
        successMessage:`${itemName} was edited`,
        customContentType:null,
        preSendManipulation:null,
        ignoreChangesTracker: ignoreChangesTracker,
        buildRequestBody:(data)=>{
            return new Promise((resolve) => {resolve(generateUpdatedVersionOfTheObject(itemId, category, data, processImmutableField))});
        }
    }
    
    const configurationsForEditForm = copyConfigurationsWithNecesseryColumns(itemAddConf, columns(), updatedParameters, customCheckBeforeSending);
    addPopup({content:Form, popupData:{configuration: configurationsForEditForm}, postSuccessAction: (val)=>{setDataMethod(val)}, EZCloseAllowed:false})
}
export const CUSTOM_SECTION_UPDATE_FORM_GENERATOR = (formTitle, link, customSaveButtonText, successMessage, columns, postSuccessAction, EZCloseable) => {
    const updatedParameters ={
        customMethod:"PATCH",
        formTitle:`${formTitle}`,
        name:`Edit`,
        addLink: link,
        customSubmitButton:customSaveButtonText,
        successMessage: successMessage,
        customContentType:null,
        preSendManipulation:null,
        
        // buildRequestBody:(data, file)=>{
        //     return new Promise((resolve) => {resolve(generateUpdatedVersionOfTheObject(itemId, category, data))});
        // }
    }
    const configurationsForEditForm = copyConfigurationsWithNecesseryColumns({columns:[]}, columns(), updatedParameters);
    addPopup({content:Form, popupData:{configuration: configurationsForEditForm}, postSuccessAction: (val)=>{postSuccessAction(val)}, EZCloseAllowed:EZCloseable})
}
export const LOAD_SECTION_UPDATE = (setDataMethod, loadId, columns, customFormTitle, customCheckBeforeSending)=>{    
    SECTION_UPDATE_FORM_GENERATOR(customFormTitle?customFormTitle:"Edit Load", "Load", "loads", loadId, LOAD_ADD_CONF, columns, setDataMethod, null, null, customCheckBeforeSending);
}
export const TRUCK_SECTION_UPDATE = (setDataMethod, truckId, columns, customFormTitle, customSaveButtonText, ignoreChangesTracker, customCheckBeforeSending)=>{
    SECTION_UPDATE_FORM_GENERATOR(customFormTitle?customFormTitle:"Edit Truck", "Truck", "trucks", truckId, TRUCK_ADD_CONF, columns, setDataMethod, customSaveButtonText, null, customCheckBeforeSending, ignoreChangesTracker);
}
export const DRIVER_SECTION_UPDATE = (setDataMethod, driverId, columns, processImmutableField)=>{
    SECTION_UPDATE_FORM_GENERATOR("Edit Driver", "Driver", "drivers", driverId, DRIVER_ADD_CONF, columns, setDataMethod, null, processImmutableField);
}
export const TRAILER_SECTION_UPDATE = (setDataMethod, trailerId, columns, customCheckBeforeSending, customAddLink)=>{
    SECTION_UPDATE_FORM_GENERATOR("Edit Trailer", "Trailer", "trailers", trailerId, TRAILER_ADD_CONF, columns, setDataMethod, null, null, customCheckBeforeSending, null, customAddLink);
}
export const COMPANY_SECTION_UPDATE = (setDataMethod, companyId, columns)=>{
    SECTION_UPDATE_FORM_GENERATOR("Edit Company", "Company", "companies", companyId, COMPANY_ADD_CONF, columns, setDataMethod);
}

export const EMPLOYEE_SECTION_UPDATE = (setDataMethod, employeeId, columns)=>{
    SECTION_UPDATE_FORM_GENERATOR("Edit Employee", "Employee", "employees", employeeId, EMPLOYEE_ADD_CONF, columns, setDataMethod);
}

export const generateColumn = (data, isNotInAddForm, label, valuePathArray, input)=>{
    if(input === undefined)input={};
    
    const columnName = Array.isArray(valuePathArray)?valuePathArray[0][0]:valuePathArray;
    const val = NestedValueExtractor(data, valuePathArray, input.dataIsInJSon);
    if(input.clickable){
        let path = NestedValueExtractor(data, input.clickable.id);
        if(path && path !== '-' && path !== ''){
            input.clickable.path = input.clickable.type + path;
        }
    }
    const result = {
        notInAddForm:isNotInAddForm,
        nameInAddConfForm: columnName,
        label: label,
        name: columnName,
        val:input && Object.keys(input).length>0?input.customDisplayFormat?input.customDisplayFormat(val):val:val,
        defaultValue:(ref)=>{
            
            if(ref !== undefined && ref.current  !== null && input.dataValueRequired){
                if(input.dataValueRequired){
                    ref.current.setAttribute('data-edited', "false");   
                }
                if(ref.current.getAttribute('data-value') === ''){
                    ref.current.setAttribute('data-value', JSON.stringify(data[columnName]));
                }
                if(data?.[columnName]?.id){
                    ref.current.setAttribute('data-old-value-id', data[columnName].id);
                }
                
            }
            if (input.customDefaultInputValue) {
                return input.customDefaultInputValue;
            }else if (input.minusAllowed){
                return val
            }else{
                return val === '-' ? '' : val;
            }
        }
    };
    for (let key in input){
        result[key] = input[key];
    }    
    return result;

}